import { render, staticRenderFns } from "./UserVerifyEmail.vue?vue&type=template&id=1256f5ee&"
import script from "./UserVerifyEmail.vue?vue&type=script&lang=js&"
export * from "./UserVerifyEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports